.centered {
  display: flex;
  align-items: center;
}

.input {
  visibility: hidden;
  position: absolute;
  height: 36px;
}

.display {
  display: block;
  width: 32px;
  height: 32px;
  margin-top: 3px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.text {
  padding-left: 10px;
  color: #000000a8;
}

.labelActive {
  cursor: pointer !important;

  &:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  }
}

.color-picker-container {
  .ant-row > .ant-col {
    .ant-form-item-control-input {
      min-height: unset;
    }
  }
}